import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { attachScript } from '../../../common/utils/attach-script';
import { URL } from '../../../common/utils/url';
import styles from './styles.scss';
const scriptApiUrl = 'https://player.vimeo.com/api/player.js';
const DEFAULT_VOLUME = 1;
let scriptPromise = null;
export class Vimeo extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "onReady", function (VimeoPlayer) {
      if (VimeoPlayer === void 0) {
        VimeoPlayer = window.Vimeo.Player;
      }
      _this.player = new VimeoPlayer(_this.iframeRef.current);
      _this.attachEventsToPlayer();
      _this.setSettings(_this.props);
    });
    this.player = null;
    this.iframeRef = /*#__PURE__*/React.createRef();
    this.muted = props.muted;
    this.__volume = 0;
  }
  componentDidMount() {
    // load once
    scriptPromise = scriptPromise || attachScript(scriptApiUrl, true);
    const ref = this.iframeRef.current;
    if (!ref) {
      this.player = null;
      return;
    }

    // TODO: replace with setting 'allow' attribute in jsx after migration to React 16
    ref.setAttribute('allow', 'autoplay');
    // if src is set before allow="autoplay", 'allow' has no effect
    ref.setAttribute('src', this.getIframeSrcUrl());
    this.props.onIframeRef(ref);
    scriptPromise.then(this.onReady);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    }
  }
  componentWillUnmount() {
    if (this.player) {
      this.detachEventsFromPlayer();
    }
  }
  attachEventsToPlayer() {
    const {
      onPlay,
      onPause,
      onEnd,
      onVolumeChange
    } = this.props;
    this.player.on('play', onPlay);
    this.player.on('pause', onPause);
    this.player.on('ended', onEnd);
    this.player.on('volumechange', onVolumeChange);
  }
  detachEventsFromPlayer() {
    const {
      onPlay,
      onPause,
      onEnd,
      onVolumeChange
    } = this.props;
    this.player.off('play', onPlay);
    this.player.off('pause', onPause);
    this.player.off('ended', onEnd);
    this.player.on('volumechange', onVolumeChange);
  }
  setSettings(_ref, prevProps) {
    let {
      isVideoPlayRequested,
      isVideoPauseRequested,
      loop,
      muted
    } = _ref;
    if (prevProps === void 0) {
      prevProps = {};
    }
    if (!this.player) {
      return null;
    }
    this.toggleMute(muted).then(() => {
      if (prevProps.isVideoPlayRequested !== isVideoPlayRequested && isVideoPlayRequested) {
        this.togglePaused(false);
      }
      if (prevProps.isVideoPauseRequested !== isVideoPauseRequested && isVideoPauseRequested) {
        this.togglePaused(true);
      }
    });
    this.toggleLoop(loop);
  }
  togglePaused(paused) {
    this.player.getPaused().then(currentPaused => {
      if (paused && !currentPaused) {
        this.player.pause();
      }
      if (!paused && currentPaused) {
        this.player.play();
      }
    });
  }
  toggleLoop(loop) {
    if (loop) {
      this.player.setLoop(true);
    } else {
      this.player.setLoop(false);
    }
  }
  toggleMute(muted) {
    return this.player.getVolume().then(volume => {
      if (muted === this.muted) {
        return Promise.resolve();
      }
      this.muted = muted;
      if (muted) {
        this.__volume = volume;
        return this.player.setVolume(0);
      }
      return this.player.setVolume(this.__volume || DEFAULT_VOLUME);
    });
  }
  getIframeSrcUrl() {
    const {
      src,
      simple,
      mobileMode
    } = this.props;
    const query = {
      muted: this.muted ? '1' : '0'
    };
    if (simple || mobileMode) {
      query.badge = '0';
      query.portrait = '0';
      query.title = '0';
    }
    const url = new URL(src);
    // https is required for autoplay
    url.protocol = 'https';
    url.search = query;
    return url.toString();
  }
  render() {
    const {
      className,
      width,
      height,
      isVideoPauseRequested,
      isVideoPlayRequested,
      isVideoPlaying,
      isVideoPaused,
      fillAllSpace
    } = this.props;
    const tabIndex = isVideoPauseRequested || isVideoPlayRequested || isVideoPlaying || isVideoPaused ? 0 : -1;
    return /*#__PURE__*/React.createElement("iframe", {
      title: "Vimeo",
      width: width,
      height: height,
      frameBorder: "0",
      allowFullScreen: true,
      tabIndex: tabIndex,
      ref: this.iframeRef,
      className: classNames(styles.iframe, className, {
        [styles.fillAllSpace]: fillAllSpace
      })
    });
  }
}
//# sourceMappingURL=vimeo.js.map